/** Matches valid email addresses. */
export const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

/** Matches phone numbers containing only digits, spaces, and common separators. */
export const PHONE_REGEX = /^[\d\s\-+()]+$/;

/**
 * Normalizes an Instagram user: trims, drops a leading '@' or a pasted profile
 * URL, lowercases. Returns null when empty and undefined when it isn't a valid
 * handle — the same convention as api/_instagram.cjs, which this mirrors (CRA
 * can't import from outside src/) and which re-normalizes server-side.
 */
export const normalizeInstagram = (value) => {
  const handle = String(value ?? '').trim()
    .replace(/^(https?:\/\/)?(www\.)?instagram\.com\//i, '')
    .replace(/[/?#].*$/, '')
    .replace(/^@/, '')
    .toLowerCase();
  if (!handle) return null;
  return /^[a-z0-9._]{1,30}$/.test(handle) ? handle : undefined;
};
